module.exports = __webpack_public_path__ + "static/media/slide-3.3e01d9f0.webp";